import { Box, ClickAwayListener, Fade, Grow, Stack } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AccountType, Color, FontStyle, JobDisplays } from "../../constants";
import FettiCheckbox from "../FettiCheckbox";
import AddIcon from "@mui/icons-material/Add";
import {
  defaultFilters,
  getExperienceTag,
  JobFilterChip,
  JobFloatScreen,
} from "../../utils/jobUtils";

const barHeight = 41;

const styles = {
  container: {
    width: "100%",
    minWidth: "",
    ...FontStyle.body,
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    position: "relative",
    cursor: "pointer",
    minHeight: barHeight,
    transition: "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
    // zIndex: 120,
    // padding: JobDisplays.padding,
    // transition: 'all 0.3s ease-in-out',
  },
  searchBar: {
    width: "100%",
    paddingLeft: "12px",
    py: 0.5,
    flexWrap: "wrap",
  },
  searchButton: {
    borderRadius: `0 ${JobDisplays.borderRadius} ${JobDisplays.borderRadius} 0`,
    color: "#888",
    width: "50px",
    minWidth: "30px",
    backgroundColor: "#ddd",
    "&:hover": {
      backgroundColor: "#ccc",
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  filtersDisplayContainer: {
    position: "absolute",
    // top: barHeight + 12,
    bottom: "-12px",
    transform: "translateY(100%)",
    left: "0",
    width: "100%",
    ...FontStyle.body,
    borderRadius: JobDisplays.borderRadius,
    border: "1px solid #0004",
    // backgroundColor: "#f00",
    backgroundColor: JobDisplays.backgroundColor,
    // boxShadow: JobDisplays.boxShadow,
    boxShadow: "2px 2px 8px rgb(0 0 0 / 10%)",
    overflow: "hidden",
    // px: "12px",
    paddingBottom: "12px",
    userSelect: "none",
  },
  filtersDisplay: {
    overflow: "scroll",
  },
};

const SectionHeader = ({ children }) => {
  return (
    <Box
      sx={{
        ...FontStyle.headingBody,
        fontSize: "14px",
        color: "#000",
        // color: "#888",
        py: "10px",
        px: "12px",
        // borderBottom: "1px solid #ddd",
      }}>
      {children}
    </Box>
  );
};

const nameFilter = (name, category) => {
  if (category === "experienceLevels") {
    return getExperienceTag({ experienceLevel: name });
  }
  return name;
};

const BulletFilter = ({ filterTitle, selected, toggleFilter, category }) => {
  const [bgColor, setBgColor] = useState("transparent");
  const flash = (color) => {
    let ts = 0;
    const interval = setInterval(() => {
      ts += 1;
      if (ts === 1 || ts === 9) {
        // if (ts === 1) {
        setBgColor(color);
      } else if (ts === 7 || ts === 16) {
        // } else if (ts === 7 || ts === 16) {
        setBgColor("transparent");
      } else if (ts > 20) {
        clearInterval(interval);
      }
    }, 1000 / 60);
  };
  useEffect(() => {}, [selected]);
  return (
    <Stack
      sx={{
        ...FontStyle.body,
        fontSize: "14px",
        color: "#000",
        // color: "#888",
        py: "5px",
        paddingLeft: "20px",
        backgroundColor: bgColor,
        "&:hover": {
          backgroundColor: bgColor === "transparent" ? "#eef" : bgColor,
        },
        // borderBottom: "1px solid #ddd",
      }}
      direction="row"
      alignItems="center"
      spacing={1}
      onClick={(e) => {
        e.stopPropagation();
        if (selected) {
          // flash("#eee");
        } else {
          flash(Color.primaryLight);
        }
        toggleFilter();
      }}>
      <FettiCheckbox selected={selected} width={14} />
      <Box>{nameFilter(filterTitle, category)}</Box>
    </Stack>
  );
};
const BulletFilterList = ({
  category,
  activeFilters,
  setActiveFilters,
  filters,
}) => {
  return (
    <>
      {filters[category].map((filter, i) => {
        return (
          <BulletFilter
            key={i}
            category={category}
            filterTitle={filter}
            selected={activeFilters[category].includes(filter)}
            toggleFilter={() => {
              setActiveFilters((activeFilters) => {
                if (activeFilters[category].includes(filter)) {
                  return {
                    ...activeFilters,
                    [category]: activeFilters[category].filter(
                      (r) => r !== filter
                    ),
                  };
                } else {
                  return {
                    ...activeFilters,
                    [category]: [...activeFilters[category], filter],
                  };
                }
              });
            }}
          />
        );
      })}
    </>
  );
};
const ClearButton = ({ active, handleClear }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Box
      sx={{ px: "12px", position: "relative" }}
      onClick={handleClear}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      <Box
        sx={{
          position: "relative",
          ...FontStyle.body,
          width: "100%",
          borderRadius: "4px",
          overflow: "hidden",
          py: "4px",
          textAlign: "center",
          marginTop: "10px",
          backgroundColor: active ? "transparent" : "#ddd",
          color: !active ? "#888" : hovered ? "#000" : "#444",
          transition: "all 0.25s ease",
          ...(hovered &&
            active && {
              letterSpacing: "0.5px",
            }),
        }}>
        <Box sx={{ position: "relative", zIndex: 2 }}>Clear Filters</Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundImage:
              "radial-gradient( circle 200px at 50% 15.5%,  #BBB0D060 10%, #BBB0D080 100.7% )",
            transition: "all 0.2s ease",
            opacity: active ? 1 : 0,
            zIndex: 0,
          }}
        />
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundImage:
              "radial-gradient( circle 200px at 50% 15.5%,  #BBB0D090 30%, #BBB0D0e0 100.7% )",
            opacity: active && hovered ? 1 : 0,
            transition: "all 0.2s ease",
            zIndex: 1,
          }}
        />
      </Box>
    </Box>
  );
};

const PlusFiltersBox = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        px: "12px",
        backgroundColor: Color.primary,
        color: "#000",
        borderRadius: `${JobDisplays.borderRadius} 0 0 ${JobDisplays.borderRadius}`,
      }}>
      <AddIcon />
      Filters
    </Stack>
  );
};

const FilterChips = ({ activeFilters, setActiveFilters, category }) => {
  return (
    <>
      {activeFilters[category].map((tag, i) => (
        <JobFilterChip
          tag={tag}
          displayName={nameFilter(tag, category)}
          key={`${category}${i}`}
          remove={() => {
            setActiveFilters((activeFilters) => {
              return {
                ...activeFilters,
                [category]: activeFilters[category].filter((t) => t !== tag),
              };
            });
          }}
        />
      ))}
    </>
  );
};

const JobFiltersBar = ({
  open,
  setOpen,
  filters,
  setFilters,
  activeFilters,
  setActiveFilters,
  setSearchBarHeight = () => {},
}) => {
  const auth = useSelector((state) => state.auth);
  const isGig = auth.accountData.accountType === AccountType.gig;
  const hasActiveFilters =
    activeFilters.roles.length > 0 ||
    activeFilters.experienceLevels.length > 0 ||
    activeFilters.locations.length > 0;
  useEffect(() => {
    // get uniques to create filters
    const roles = [...new Set(auth.jobs.map((job) => job.roleToken))].sort();
    const locationsList = [];
    auth.jobs.forEach((job) => {
      if (job.location) {
        locationsList.push(job.location);
      }
      if (job.locations) {
        job.locations.forEach((location) => {
          locationsList.push(location);
        });
      }
    });
    const locations = [...new Set(locationsList)].sort();
    // const locations = [...new Set(auth.jobs.map((job) => job.location))].sort();
    const experienceLevels = [
      // filter only integers
      ...new Set(
        auth.jobs
          .filter((job) => Number.isInteger(job.experienceLevel))
          .map((job) => job.experienceLevel)
      ),
    ].sort();
    console.log("new experience levels", experienceLevels);
    setFilters({ roles, locations, experienceLevels });
    setActiveFilters(JSON.parse(JSON.stringify(defaultFilters)));
    // setActiveFilters({ roles, locations, experienceLevels });
  }, [auth.jobs]);
  const handleHeight = useCallback((node) => {
    if (!node) return;
    setSearchBarHeight(node.clientHeight);
    const resizeObserver = new ResizeObserver(() => {
      if (!node) return;
      setSearchBarHeight(node.clientHeight);
    });
    resizeObserver.observe(node);
  }, []);
  return (
    <Box
      ref={handleHeight}
      sx={{
        width: "100%",
      }}>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Stack
          direction="row"
          sx={{
            ...styles.container,
            "&:hover": {
              transform: "scale(1.01)",
            },
            ...(open && {
              zIndex: 2002,
              boxShadow:
                "0px 0px 10px #0AE9F080, 0px 0px 10px #0110FA80, 0px 0px 5px #0110FA80",
              transform: "scale(1.01)",
            }),
          }}
          onClick={() => setOpen(!open)}>
          <PlusFiltersBox />
          <Stack
            direction="row"
            sx={styles.searchBar}
            alignItems="center"
            gap={0.9}>
            <FilterChips
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              category="roles"
            />
            <FilterChips
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              category="locations"
            />
            <FilterChips
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              category="experienceLevels"
            />
            {/* {activeFilters.roles.map((tag, i) => (
              <JobFilterChip tag={tag} key={`r${i}`} />
            ))} */}
            {/* {activeFilters.locations.map((tag, i) => (
              <JobFilterChip tag={tag} key={`l${i}`} />
            ))}
            {activeFilters.experienceLevels.map((tag, i) => (
              <JobFilterChip tag={tag} key={`e${i}`} />
            ))} */}
          </Stack>
          {/* <Box sx={styles.searchButton}>🔎</Box> */}
          {/* {open && ( */}
          <Fade in={open}>
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                ...styles.filtersDisplayContainer,
                // maxHeight: "0",
              }}>
              <Stack sx={styles.filtersDisplay} direction="column">
                <SectionHeader>Roles</SectionHeader>
                <BulletFilterList
                  category="roles"
                  activeFilters={activeFilters}
                  setActiveFilters={setActiveFilters}
                  filters={filters}
                />
                <SectionHeader>Locations</SectionHeader>
                <BulletFilterList
                  category="locations"
                  activeFilters={activeFilters}
                  setActiveFilters={setActiveFilters}
                  filters={filters}
                />
                {!isGig && (
                  <>
                    <SectionHeader>Experience Level</SectionHeader>
                    <BulletFilterList
                      category="experienceLevels"
                      activeFilters={activeFilters}
                      setActiveFilters={setActiveFilters}
                      filters={filters}
                    />
                  </>
                )}
                <ClearButton
                  active={hasActiveFilters}
                  handleClear={() =>
                    setActiveFilters(JSON.parse(JSON.stringify(defaultFilters)))
                  }
                />
              </Stack>
            </Box>
          </Fade>
          {/* )} */}
        </Stack>
      </ClickAwayListener>
      {open && <JobFloatScreen zIndex={1} />}
    </Box>
  );
};

export default JobFiltersBar;
